import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllArticulos } from "../../../redux/articulos/articulosAction";
import Select from 'react-select';
import {customStyles} from './selectArticulos'
import { TbRuler2 } from "react-icons/tb";

export default function OtrosArticulos({index, articuloIn, onDelete, onArticuloChange}){
    const dispatch = useDispatch();
    const articulos = useSelector(state => state.articulos.allArticulos)    
    const [articulo, setArticulo] = useState(articuloIn);
    const [id] = useState(() => crypto.randomUUID());
    //console.log(articuloIn);
    
       
    useEffect(() => {
        dispatch(getAllArticulos())
    }, [dispatch]);    

     useEffect(() => {
         setArticulo(articuloIn.id ? articuloIn : {...articuloIn, id})
     }, [articuloIn]);

        
    const handleCantidad = (e) => {
        const { value } = e.target;
        //console.log(value);
              
        setArticulo({
          ...articulo,
          cantidad: value,
          //precioTotal: articulo.precio * value,
        });       
      };

    const handleKey = (e) => {
        const {value} = e.target
        console.log(value);        
        console.log(e.key);
        console.log(articulo.cantidad);
              
        if(value && articulo.cantidad){
            if(e.key === 'Enter'){            
                const updatedArticulo = {
                    ...articulo,
                    precioTotal: parseFloat(articulo.precio) * articulo.cantidad
                }
                //console.log(updatedArticulo);
                
    
                setArticulo(updatedArticulo)
                onArticuloChange(updatedArticulo) 
            }
        } 
    }

    const handleChange = (e) => {
        const {value} = e.target
        setArticulo({
            ...articulo,
            [e.target.name]: value
        })
    }

    return (
        <>  
        <div className="border text-[10pt] font-bold">           
            <table>               
                <tbody>
                    <tr>
                        <td className="w-[95px]">                                                    
                        </td>
                        <td className="w-[600px] pl-2 border-l">
                            {/* {articulo.nombre ? articulo.nombre : "nombre"} */}
                            <input 
                            className="w-[582px]"
                            name="nombre"
                            onChange={handleChange}
                            value={articulo.nombre || ""}
                            />
                        </td>
                        <td className="w-[120px] text-center border-l">
                            {/* {articulo.ciclo ? articulo.ciclo : "ciclo"} */}
                            <input 
                                className="w-[110px]"
                                name="ciclo"
                                onChange={handleChange}
                                value={articulo.ciclo || ""}
                            />
                        </td>
                        <td className="w-[135px] text-center border-l">
                            <input 
                                className="w-[125px]"
                                name="isbn"
                                onChange={handleChange}
                                value={articulo.isbn || ""}
                            />
                            {/* {articulo.isbn ? articulo.isbn : "isbn"} */}
                        </td>
                        <td className="w-[80px] border">
                            <input 
                                className="w-[76px] text-right"
                                type="number"
                                value={articulo.cantidad}
                                onChange={handleCantidad}
                                //onKeyUp={handleKey}
                            />
                        </td>
                        <td className="w-[80px] text-right border-l">
                            {/* {articulo.precio ? articulo.precio : null} */}
                            <input 
                                className="w-[76px] text-right"
                                name="precio"
                                onChange={handleChange}
                                onKeyUp={handleKey}
                                value={articulo.precio || ""}
                            />
                        </td>
                        <td className="w-[80px] pr-1 text-right border-x">
                            {articulo.precioTotal ? articulo.precioTotal : null}
                        </td>
                        <td><button onClick={onDelete}>Eliminar</button></td>
                    </tr>
                </tbody>
            </table>
        </div>                    
        </>
    )
}